import { render, staticRenderFns } from "./BookingSuccess.vue?vue&type=template&id=05c23589&scoped=true"
import script from "./BookingSuccess.vue?vue&type=script&lang=js"
export * from "./BookingSuccess.vue?vue&type=script&lang=js"
import style0 from "./BookingSuccess.vue?vue&type=style&index=0&id=05c23589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c23589",
  null
  
)

export default component.exports